.root {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  min-width: min(1024px, 100%);
  margin-left: auto;
  margin-right: auto;
}

.headerControls {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  justify-content: space-between;
  align-items: center;
  transform: rotate(0);
  transition: opacity 195ms cubic-bezier(0.4, 0, 0.6, 1);
}

.headerLeft {
  justify-self: left;
}

.headerRight {
  justify-self: right;
}

/* Header controls stay quiet without fading: secondary text colour meets 4.5:1, where 50% opacity gave ~2.3:1 */
.quiet button:not(:disabled) {
  color: var(--tuna-content-secondary);
}

.quiet button:not(:disabled):hover,
.quiet button:focus-visible {
  color: var(--tuna-palette-primary-main);
}

/* Header with a metadata slot: left-aligned title block, then one metadata row */
.headerStack {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3) 32px 0;
}

.metaRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.spacer {
  flex: 1;
}

/* Sentence case, as the row's labels read ("2 backlinks", "View") */
.metaRow button {
  text-transform: none;
}

.viewButton {
  border-radius: var(--tuna-shape-radius-pill);
}

@media (max-width: 599.95px) {
  .headerStack {
    padding: var(--tuna-spacing-2) 8px 0;
  }
}

.contentBox {
  flex: 1;
  flex-direction: column;
  display: flex;
  width: 100%;
  margin: auto;
  padding: 0 32px 0 32px;
  transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1);
}

@media (max-width: 599.95px) {
  .contentBox {
    padding: 0 8px;
  }
}
